import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import { loadFavoriteOrganizations } from '../actions';
import OrganizationList from '../components/OrganizationList';


class ProfileFavorites extends Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    const { auth } = nextProps;

    if(!auth.isLoading && !auth.user) {
      alert(1)
      this.props.push('/')
      return
    }

    if (!auth.isLoading && auth.user) {
      let oldLen = this.props.auth.user ? this.props.auth.user.favorites.length : 0;
      let newLen = nextProps.auth.user ? nextProps.auth.user.favorites.length : 0;
      if(oldLen != newLen) {
        let orgids = nextProps.auth.user.favorites.map(org => {
          return org.organization
        });
        if(orgids.length > 0) {
          nextProps.loadFavoriteOrganizations({ organization_ids: orgids });
        }
      }
    }
  }

  componentWillMount() {
    const { auth } = this.props;
    if (!auth.isLoading && !auth.user) {
      this.props.push('/')
      return
    }
  }

  componentWillMount() {
    const { auth } = this.props;

    if(!auth.isLoading && !auth.user) {
      this.props.push('/');
    }

    if(this.props.auth.user && this.props.auth.user.favorites.length > 0) {
      let orgids = this.props.auth.user.favorites.map(org => {
        return org.organization;
      });
      this.props.loadFavoriteOrganizations({ organization_ids: orgids });
    }
  }

  render() {

    let favorites = [];
    const { user } = this.props.auth;


    if(user && user.favorites && user.favorites.length > 0) {
      favorites = <OrganizationList user={user} organizations={this.props.favoriteOrganizations} />;
    }
    else {
      favorites = <Link to="/" className="noFavoritesButton">
            Start exploring
            <br/>
            and save what you like best.
          </Link>;
    }

    return (
      <div>
        <h1>My Favorites</h1>
        <div className="profile-favoriteList">
          { favorites }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  {
    push,
    loadFavoriteOrganizations
  }
)(ProfileFavorites);



// WEBPACK FOOTER //
// ./src/containers/ProfileFavorites.jsx